import styled from 'styled-components';

export interface IFloatingBubbleBoxProps {
    isVisible: boolean;
}

export const FloatingBubbleBox = styled.div<IFloatingBubbleBoxProps>`
  display: ${props => props.isVisible ? 'block' : 'none'};
`;
